import { AxiosResponse } from 'axios';
import { jobBoardAPI } from './base';
import { Employee } from 'data/users';

interface UpdateProfilePayload {
  email: string;
  password?: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  username: string;
  mentionNotificationPreference?: string;
  taskNotificationPreference?: string;
  jobWatchNotificationPreference?: string;
  smsConsent?: boolean;
  jobStageNotificationPreferences?: Array<{
    stageId: string;
    preference: string;
  }>;
}

export const updateProfile = async (
  payload: UpdateProfilePayload
): Promise<AxiosResponse> => {
  try {
    const response = await jobBoardAPI.patch('/auth/update-profile', payload);
    return response;
  } catch (error) {
    console.error('Error updating profile:', error);
    throw new Error('Error updating profile', { cause: error });
  }
};

export const getProfile = async (): Promise<Employee> => {
  try {
    const response = await jobBoardAPI.get('/auth/me');
    return response.data;
  } catch (error) {
    console.error('Error fetching profile:', error);
    throw new Error('Error fetching profile', { cause: error });
  }
};
